

// collection products slider
  $(document).ready(function () {
    var productSwiper = new Swiper('.collection_product_Swiper', {
      loop: true,
      slidesPerView: 1,
      spaceBetween: 10,
      pagination: {
        el: '.collection_product_Swiper .swiper-pagination',
        clickable: true,
      },
      navigation: {
        nextEl: '.collection_product_Swiper .swiper-button-next',
        prevEl: '.collection_product_Swiper .swiper-button-prev',
      },
 
    });
  });





   $(document).on('click', '.pdp_upsell_product .pro_atc_btn', function(e) {
  e.preventDefault();

  var var_id = $(this).attr('product_id');
  var qty = 1;

  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: { id: var_id, quantity: qty },
    dataType: 'json',
    success: function() {
      document.dispatchEvent(new CustomEvent('cart:build'));
      $('body').addClass('js-drawer-open');
      $('#CartDrawer').addClass('drawer--is-open');
    },
    error: function(xhr) {
      console.error(xhr.responseText);
      alert('Error adding to cart');
    }
  });
});
$(document).on('click', '.js-drawer-close', function(e) {
  e.preventDefault();
  closeCartDrawer();
});

function closeCartDrawer() {
  $('#CartDrawer').removeClass('drawer--is-open');
  $('body').removeClass('js-drawer-open');
}



$(document).ready(function() {

  // ✅ Function to update product buttons based on current cart
  function checkCartItems() {
    $.getJSON('/cart.js', function(cart) {
      $('.product_atc_button').each(function() {
        var btn = $(this);
        var variant_id = btn.attr('pro_id');
        var inCart = cart.items.some(item => item.id == variant_id);

        if (inCart) {
          btn.closest('.product_link').addClass('active');
          btn.find('.add_product').hide();
          btn.find('.remove_product').show();
        } else {
          btn.closest('.product_link').removeClass('active');
          btn.find('.add_product').show();
          btn.find('.remove_product').hide();
        }
      });
    });
  }

  // ✅ Run on page load
  checkCartItems();

  // ✅ When Add/Remove button clicked on product card
  $(document).on('click', '.product_upsell .product_atc_button', function(e) {
    e.preventDefault();
    var btn = $(this);
    var variant_id = btn.attr('pro_id');
    var isActive = btn.closest('.product_link').hasClass('active');

    if (!isActive) {
      // 👉 Add to cart
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: { id: variant_id, quantity: 1 },
        dataType: 'json',
        success: function() {
          btn.closest('.product_link').addClass('active');
          btn.find('.add_product').hide();
          btn.find('.remove_product').show();

          document.dispatchEvent(new CustomEvent('cart:build'));
          $('body').addClass('js-drawer-open');
          $('#CartDrawer').addClass('drawer--is-open');
        },
        error: function(xhr) {
          console.error(xhr.responseText);
          alert('Error adding to cart');
        }
      });
    } else {
      // 👉 Remove from cart
      $.getJSON('/cart.js', function(cart) {
        var item = cart.items.find(i => i.id == variant_id);
        if (item) {
          $.ajax({
            type: 'POST',
            url: '/cart/change.js',
            data: { id: variant_id, quantity: 0 },
            dataType: 'json',
            success: function() {
              btn.closest('.product_link').removeClass('active');
              btn.find('.add_product').show();
              btn.find('.remove_product').hide();

              document.dispatchEvent(new CustomEvent('cart:build'));
              $('body').addClass('js-drawer-open');
              $('#CartDrawer').addClass('drawer--is-open');
            },
            error: function(xhr) {
              console.error(xhr.responseText);
              alert('Error removing from cart');
            }
          });
        }
      });
    }
  });

  // ✅ When quantity is adjusted anywhere in cart
  $(document).on('click', '.js-qty__adjust', function() {
    // Wait a moment for the cart to update
    setTimeout(function() {
      checkCartItems();
    }, 500);
  });

  // ✅ Optional: also refresh buttons whenever cart updates (theme event)
  document.addEventListener('cart:updated', function() {
    checkCartItems();
  });

 
 $(".product___column_flex .prod_colll").click(function(){
   if ($(window).width() <= 480){
      $(".product___column_flex .prod_colll").removeClass("two");
       $(".grid__item.grid-product.small--one-half.medium-up--one-third").css("width", "50%");

    $(this).addClass("two");
    if ($(".product___column_flex .prod_colll.one").hasClass("two")){
        $(".grid__item.grid-product.small--one-half.medium-up--one-third").css("width", "100%");
    }
      }else{

       $(".grid__item.grid-product.small--one-half.medium-up--one-third").css("width", "33.33%");
  }
  })


 


  $(".main_product .product__main-photos .dimension_tab").click(function(){
     $(".main_product .product__thumbs--beside .product__thumb-item img[alt='dimension']").trigger("click");
  })


 
  $('section.sticky_atccc .sticky-atc-btn').click(function (e) {
    e.preventDefault();
  

    $('button.btn.btn--full.add-to-cart').trigger('click');
  });


});


$(document).ready(function () {

  const $tab = $(".dimension_tab");
  const $overlay = $(".dimension_popup_overlay");
  const $popupContent = $(".dimension_popup_content");
  const $closeBtn = $(".pop_up_cross");

  if ($tab.length && $overlay.length) {

    // Show popup + disable scroll
    $tab.on("click", function () {
      $overlay.addClass("active");
      $("body").css("overflow", "hidden");
    });

    // Close on clicking outside popup
    $overlay.on("click", function (e) {
      if (
        !$popupContent.is(e.target) &&
        $popupContent.has(e.target).length === 0
      ) {
        $overlay.removeClass("active");
        $("body").css("overflow", "");
      }
    });

    // Close when clicking the cross button
    $closeBtn.on("click", function () {
      $overlay.removeClass("active");
      $("body").css("overflow", "");
    });

  }

});


